import {
  Icon,
  IconName,
  Pressable,
  Text,
  TextVariant,
  useToast,
} from '@rbilabs/universal-components';
import { Clipboard } from 'react-native';

export const CopyButton = (props: {
  label: string;
  textToCopy: string;
  variant?: TextVariant;
  iconName?: IconName;
}) => {
  const toast = useToast();
  return (
    <Pressable
      onPress={() => {
        toast.show({ text: `Copied to Clipboard: ${props.label}` });
        Clipboard.setString(props.textToCopy);
      }}
      flexDirection="row"
      alignItems="center"
    >
      <Text variant={props.variant} marginTop="$2" marginBottom="$2">
        {props.label}
      </Text>
      {props.iconName ? <Icon name={props.iconName} size="xs" marginLeft="$2" /> : null}
    </Pressable>
  );
};
